import React from "react";
import { PieChart } from "react-minimal-pie-chart";

const QuizResultPieChart = ({
  nofCorr = 0,
  nofInCorr = 0,
  nofUnAns = 0,
  noOfPartialAnswered = 0,
}) => {
  const studyData = [];

  const addSeparator = (value) => {
    if (value !== 0) {
      studyData.push({ title: "", value: 0.2, color: "#FFFFFF" });
    }
  };

  // Correct
  studyData.push({
    title: "Correct",
    value: nofCorr,
    color: "#85BC20",
  });
  addSeparator(nofCorr);

  // Incorrect
  studyData.push({
    title: "Incorrect",
    value: nofInCorr,
    color: "#E5202E",
  });
  addSeparator(nofInCorr);

  // Partial Answered
  studyData.push({
    title: "Partial",
    value: noOfPartialAnswered,
    color: "#0096FF",
  });
  addSeparator(noOfPartialAnswered);

  // Unanswered
  studyData.push({
    title: "Unanswered",
    value: nofUnAns,
    color: "#ECECEC",
  });

  return (
    <PieChart
      startAngle={270}
      lengthAngle={360}
      lineWidth={35}
      data={studyData}
      animate
    />
  );
};

export default QuizResultPieChart;
